import { Component, Input, Optional } from '@angular/core';
import { getRouterLinkById, ITableColumn } from '@lsq-frontend/common-ui';
import { LsqBaseColumnComponent, LsqDataTableComponent } from '@lsq-frontend/common-ui';
import { atlas, INCREASE_CREDIT_LIMIT } from '@lsq-frontend/fasttrack-shared/routing-atlas';

@Component({
    selector: 'lsq-customer-credit-limit-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                [ngClass]="[classNames.Sortable, classNames.AlignRight]"
                (click)="changeSort()"
            >
                <div class="th-content">
                    Credit Limit
                    <div *ngIf="isSortable$ | async">
                        <lsq-icon
                            class="sort-caret"
                            [ngClass]="{ 'is-sorted': isCurrentlySorted() }"
                            [type]="getIconType()"
                            [color]="getIconColor()"
                        >
                        </lsq-icon>
                    </div>
                </div>
            </th>
            <td
                cdk-cell
                *cdkCellDef="let row; let index = index"
                [ngClass]="[classNames.Sortable, classNames.AlignRight]"
            >
                <span class="customer-credit-limit">{{ row.creditLimit | currencyDash }}</span>
                <ng-container *ngIf="!row.isNoBuy">
                    <a
                        class="customer-credit-limit-increase font-weight-bold"
                        [queryParams]="{ key: row.debtorKey }"
                        [routerLink]="getIncreaseCreditLimitRouterLink()"
                    >
                        INCREASE
                    </a>
                </ng-container>
            </td>
        </ng-container>
    `,
    styleUrls: ['./credit-limit-column.component.scss']
})
export class CustomerCreditLimitColumnComponent extends LsqBaseColumnComponent {
    @Input() public column: ITableColumn = {
        key: 'creditLimit',
        header: 'Credit Limit'
    };

    constructor(@Optional() public dataTable: LsqDataTableComponent) {
        super(dataTable);
    }

    public getIncreaseCreditLimitRouterLink(): string[] {
        return getRouterLinkById(atlas, INCREASE_CREDIT_LIMIT);
    }
}
